import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IJSONProvider} from "data/providers/json/json.provider";
import {Bindings} from "data/constants/bindings";
import {TournamentStatus} from "data/enums/torunaments";

export interface ITournament {
	id: number;
	feedId: number;
	contestId: number;
	homeSquadId: number;
	awaySquadId: number;
	startDate: string;
	status: TournamentStatus;
	homeSquadScore: null;
	awaySquadScore: null;
	inningOrdinal: string;
	inningState: string;
}

export interface ITournamentsStore {
	get list(): ITournament[];
	get activeTournaments(): ITournament[];
	getTournamentById(tournamentId: number): ITournament | undefined;

	fetchTournaments(): Promise<void>;
}

@injectable()
export class TournamentsStore implements ITournamentsStore {
	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	@observable private _list: ITournament[] = [];

	get list() {
		return this._list;
	}

	get activeTournaments() {
		return this._list.filter((it) => it.status === TournamentStatus.PLAYING);
	}

	public getTournamentById(tournamentId: number): ITournament | undefined {
		return this._list.find((it) => it.id === tournamentId);
	}

	@action
	async fetchTournaments() {
		const {data} = await this._jsonProvider.tournaments();

		runInAction(() => {
			this._list = data.items;
		});
	}
}
